module.exports = __webpack_public_path__ + "static/img/ic-o.caa81f10.svg";